import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { SideBar } from "./SideBar";
import { TopBar } from "./TopBar";
import "../../pages/admin/Dashboard.css";

const SUPPORTED_LANGS = ["en", "fr", "de", "es", "nl", "pt"];

function resolveLangCode(raw) {
  if (!raw || typeof raw !== "string") return null;
  const s = raw.trim();
  const two = s.substring(0, 2).toLowerCase();
  if (SUPPORTED_LANGS.includes(two)) return two;
  const map = {
    french: "fr",
    français: "fr",
    english: "en",
    german: "de",
    deutsch: "de",
    spanish: "es",
    español: "es",
    dutch: "nl",
    nederlands: "nl",
    portuguese: "pt",
    português: "pt",
    portugues: "pt",
  };
  return map[s.toLowerCase()] || null;
}

const AdminLayout = ({ children }) => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const stored =
      localStorage.getItem("i18nextLng") || localStorage.getItem("lng");
    const code = resolveLangCode(stored);
    if (!code) return;
    const current = (i18n.language || "en").substring(0, 2).toLowerCase();
    if (current !== code) {
      i18n.changeLanguage(code);
    }
  }, []);

  return (
    <>
      <div id="dashboard" className="admin-theme-root">
        <div id="sidebar">
          <SideBar />
        </div>

        <div id="content">
          <TopBar />
          {children}
        </div>
      </div>
    </>
  );
};
export default AdminLayout;
